import { HierarchyControlItem } from "../../HierarchyControl.types";
import { Hierarchy } from "../../models/Hierarchy";

export interface BaseTreeProps<T> {
  selectableParent?: boolean;
  children: JSX.Element | JSX.Element[];
  expanded?: T[];
  className?: string;
  // onToggle: (event: React.ChangeEvent<{}>, nodeIds: T[]) => void;
}

export interface SingleTreeProps<T> extends BaseTreeProps<T> {
  onSelect: (event: React.ChangeEvent<{}>, nodeId: T) => void;
  selected: T;
}

export interface MultiTreeProps<T> extends BaseTreeProps<T> {
  onSelect: (event: React.ChangeEvent<{}>, nodeIds: T[]) => void;
  selected: T[];
  multiple: boolean;
}

export type TreeProps<T> = SingleTreeProps<T> | MultiTreeProps<T>;

export interface TreeItemProps<T> {
  hierarchy: Hierarchy<T, HierarchyControlItem<T>>;
  disabled?: boolean;
}

export enum DataTreeType  {
  ToggleIcon = "toggle-icon",
  Parent = "parent",
  Node = "node",
}